/* Pure Leaf: customer photos in reviews open full screen on the page
   instead of a new tab. Works with the review cards built in
   sections/pure-leaf-landing.liquid (.pl-rv-pics links). */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.pl-rv-pics a{cursor:zoom-in}' +
    '.pl-rv-viewer{position:fixed;inset:0;z-index:10050;display:flex;align-items:center;justify-content:center;background:rgba(16,24,19,.94);opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s}' +
    '.pl-rv-viewer.open{opacity:1;visibility:visible}' +
    '.pl-rv-viewer img{max-width:94vw;max-height:86vh;object-fit:contain;border-radius:.8rem}' +
    '.pl-rv-viewer button{position:absolute;border:0;border-radius:999px;cursor:pointer;width:3rem;height:3rem;background:rgba(251,248,243,.14);color:#FBF8F3;font-size:1.6rem;line-height:1;display:flex;align-items:center;justify-content:center}' +
    '.pl-rv-viewer button[hidden]{display:none}' +
    '.pl-rv-viewer .pv-close{top:1rem;right:1rem}' +
    '.pl-rv-viewer .pv-prev{left:1rem;top:50%;transform:translateY(-50%)}' +
    '.pl-rv-viewer .pv-next{right:1rem;top:50%;transform:translateY(-50%)}' +
    '.pl-rv-viewer .pv-count{position:absolute;bottom:1.2rem;left:0;right:0;text-align:center;color:rgba(251,248,243,.7);font-size:.75rem;letter-spacing:.15em}' +
    'body.pv-open{overflow:hidden}';
  document.head.appendChild(style);

  var box = null, img, count, list = [], idx = 0;

  function build() {
    box = document.createElement('div');
    box.className = 'pl-rv-viewer';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Customer photo');
    box.innerHTML = '<img alt="Customer photo">' +
      '<button type="button" class="pv-close" aria-label="Close">×</button>' +
      '<button type="button" class="pv-prev" aria-label="Previous photo">‹</button>' +
      '<button type="button" class="pv-next" aria-label="Next photo">›</button>' +
      '<div class="pv-count"></div>';
    document.body.appendChild(box);
    img = box.querySelector('img');
    count = box.querySelector('.pv-count');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.pv-prev')) return show(idx - 1);
      if (e.target.closest('.pv-next')) return show(idx + 1);
      if (e.target !== img) close();
    });
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40 && list.length > 1) show(idx + (dx < 0 ? 1 : -1));
    });
  }

  function show(i) {
    idx = (i + list.length) % list.length;
    img.src = list[idx];
    count.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    box.querySelector('.pv-prev').hidden = list.length < 2;
    box.querySelector('.pv-next').hidden = list.length < 2;
  }

  function close() {
    box.classList.remove('open');
    document.body.classList.remove('pv-open');
  }

  /* capture phase, so the link never opens a new tab */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.pl-rv-pics a, .pl-rv-pics [data-rv-pic]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    if (!box) build();
    var all = link.closest('.pl-rv-pics').querySelectorAll('a, [data-rv-pic]');
    list = Array.prototype.map.call(all, function (a) { return a.getAttribute('href') || a.dataset.rvPic; });
    show(Math.max(0, Array.prototype.indexOf.call(all, link)));
    box.classList.add('open');
    document.body.classList.add('pv-open');
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(idx - 1);
    if (e.key === 'ArrowRight') show(idx + 1);
  });
})();
